import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { isChatterAllowed } from '../services/chatter/is-chatter-allowed';
import { TripService } from '../services/trip.service';

export const chatterGuard: CanActivateFn = () => {
  const tripService = inject(TripService);
  const router = inject(Router);

  if (!tripService.currentTripLoaded()) {
    return true;
  }

  const trip = tripService.currentTrip.value();
  return isChatterAllowed(trip) ? true : router.createUrlTree(['/dashboard']);
};
